










































































































































import { Vue, Component } from 'vue-property-decorator'
import { exportJson2Excel } from '@/utils/excel'
import { formatJson, deepCopy, getPackageSize } from '@/utils/tool'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'
import moment from 'moment'
import {
  getDesktopVersionList,
  getDesktopVersionDetail,
  saveTutuDesktopVersion
} from '@/api/production/production'

@Component({
  name: 'ProductionPCList'
})
export default class extends mixins(DateOption) {
  // data
  params = {
    type: 'mac',
    page: 1,
    updateDateStart: '',
    updateDateEnd: '',
    pageCount: 20
  }
  tableLoading = false
  tableData: any[] = []
  totalCount: number = 0
  dateArray: string[] = ['', '']
  tableHeight: number = 500
  moment = moment
  getPackageSize = getPackageSize
  // lifecycle
  created() {
    let { platform } = this.$route.query
    if (platform) {
      this.params.type = platform as string
    }
    this.getTableData()
  }
  mounted() {
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.setTableHeight)
    })
  }
  // methods
  async getTableData() {
    this.tableLoading = true
    this.tableData = []
    let res: any = await getDesktopVersionList(this.params)
    this.tableData = res.data.dataList || []
    this.tableLoading = false
  }
  setTableHeight() {
    this.tableHeight = document.body.clientHeight - 310
  }
  handleSearch() {
    if (this.tableLoading) { return false }
    this.params.page = 1
    let params: any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleChange(platform: string) {
    this.getTableData()
    this['$router'].push({
      query: {
        platform
      }
    })
  }
  handleDateChange(date: string[] | any) {
    this.params.updateDateStart = date && date[0]
    this.params.updateDateEnd = date && date[1]
  }
  handleReset() {
    this.params.page = 1
    this.dateArray = ['', '']
  }
  handleAdd() {
    this['$router'].push({
      name: 'ProductionPCAdd'
    })
  }
  handleEdit(item: any) {
    this['$router'].push({
      name: 'ProductionPCEdit',
      query: {
        id: item.id
      }
    })
  }
  handleView(item: any) {
    this['$router'].push({
      name: 'ProductionPCView',
      query: {
        id: item.id
      }
    })
  }
  handleExcel() {
    // let excelParams = deepCopy(this.params)
    // let res: any = await getIosList(
    //   Object.assign(excelParams, {
    //     page: 1,
    //     pageCount: 3000
    //   })
    // )
    // if (res.status.code === 0) {
    //   this['$message'].success('导出成功')
    // } else {
    //   this['$message'].error('导出失败')
    //   return
    // }
    // const filterVal: string[] = [
    //   'id',
    //   'name',
    //   'developer',
    //   'category',
    //   'source',
    //   'version',
    //   'price',
    //   'socre',
    //   'status',
    //   'editor',
    //   'updateDate'
    // ]
    // const theader: string[] = [
    //   'ID',
    //   '名称',
    //   '开发者',
    //   '类别',
    //   '来源',
    //   '版本',
    //   '价格',
    //   '评分',
    //   '应用状态',
    //   '编辑人',
    //   '最后修改时间'
    // ]
    // const list = res.data.dataList
    // const data = formatJson(filterVal, list)
    // exportJson2Excel(theader, data)
  }
}
